<template>
  <v-app-bar app flat light class="app-topbar" height="64">
    <v-app-bar-nav-icon
      class="app-topbar-toggle"
      @click.stop="$root.$emit('open-close-nav')"
    ></v-app-bar-nav-icon>
    <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
      <span class="hidden-sm-and-down"></span>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <div class="tw-flex tw-items-center">
      <div class="app-topbar-notif">
        <acp-notifications></acp-notifications>
      </div>
      <app-avatar> </app-avatar>
    </div>
  </v-app-bar>
</template>

<script>
export default {
  components: {
    appAvatar: () => import('@/components/navigation/AvatarMenu'),
    acpNotifications: () => import('@/components/notifications/Notifications'),
  },
}
</script>

<style scoped>
.app-topbar {
  background: #ffffff !important;
  border-bottom: 1px solid #e8edf5;
  box-shadow: 0 2px 12px rgba(15, 42, 85, 0.05) !important;
}
.app-topbar-toggle {
  color: #0f2a55;
}
/* Soft divider before the profile chip (replaces the hard 2px gray border) */
.app-topbar-notif {
  padding-right: 16px;
  margin-right: 4px;
  border-right: 1px solid #e8edf5;
}
</style>
